import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ErrorPanel,
  FullScreenOverlay,
  LoadingIndicator,
} from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../shared/constants';
import { ResourcesSidebarLayout } from './common/components';
import { NoFolders } from './folders/components';
import { useFolderTree } from './folders/context';
import { Favourites } from './favourites';
import { Folders } from './folders';
import { PendingApproval } from './pending-approval';
import { Recents } from './recents';
import { Uploads } from './uploads';

export const ResourcesView = () => {
  const { pathname } = useLocation();
  const { data, error, isLoading, isError } = useFolderTree();

  const [
    showResourceView,
    showPendingApproval,
    showFavourites,
    showRecents,
    showUploads,
  ] = useMemo(
    () => [
      [
        PATHS.PendingApproval,
        PATHS.Favourites,
        PATHS.Recents,
        PATHS.Uploads,
      ].includes(pathname),
      pathname === PATHS.PendingApproval,
      pathname === PATHS.Favourites,
      pathname === PATHS.Recents,
      pathname === PATHS.Uploads,
    ],
    [pathname]
  );

  if (isLoading) {
    return (
      <FullScreenOverlay>
        <LoadingIndicator />
      </FullScreenOverlay>
    );
  }

  if (isError) {
    return (
      <FullScreenOverlay>
        <ErrorPanel error={error} />
      </FullScreenOverlay>
    );
  }

  if (!data?.length) {
    return <NoFolders />;
  }

  return (
    <ResourcesSidebarLayout>
      <>
        {showResourceView ? (
          <>
            {showPendingApproval && <PendingApproval />}
            {showFavourites && <Favourites />}
            {showRecents && <Recents />}
            {showUploads && <Uploads />}
          </>
        ) : (
          <Folders />
        )}
      </>
    </ResourcesSidebarLayout>
  );
};
